import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ViewShareWithNeighborsPage() {
  useRequireSectionVisible("showShareWithNeighbors");
  return <CommunityViewPage section={SHARE_WITH_NEIGHBORS} />;
}
